<app-fixed-editor *ngIf="_element.editorId && fixedEditor && !isSubmitted" [element]="fixedEditor"></app-fixed-editor>
<div *ngIf="!isSubmitted && !immediateFeedBackRequired" [attr.id]="'destination'+index"
  class="new-question new-question-top-align mx-auto" [class.fullheight-scroll-container]="!isSubmitted">
  <div class="new-question__container next-button-spacing">
    <div class="new-question-para-desc pl-0 pr-0">
      <div class="new-question-para-desc__inner">
        <div class="new-question__container">
          <div [froalaView]="_element?.question" class="mg-b10 font-16 lh-30 font-mob-14 lh-mob-24"></div>
        </div>
      </div>
      <a href="javascript:void(0)" class="bottom-tab-arrow"></a>
    </div>
    <div *ngIf="showSlick" class="new-question-rating-slider">
      <ngx-slick #slickModalInner [config]="slideConfig1" (afterChange)="slickChange($event)">
        <div ngxSlickItem *ngFor="let opt of _element?.options;index as i">
          <div class="new-question--titleBox">
            <h3 class="new-question--title">{{opt.text}}</h3>
          </div>
          <div class="new-options new-options__full-width new-options--rating-list">
            <div *ngFor="let r of opt.rowsOptions;index as j"
              class="new-options--rating new-options--radio w-auto text-center">
              <input type="radio" [checked]="answersMap[i] == r._id" (change)="radioState(i,opt._id,r._id)"
                [name]="opt._id">
              <span class="new-options--color"></span>
              <span class="new-options--title new-options--rating__title"><strong>{{r?.text}}</strong></span>
              <span class="new-options--subtitle new-options--rating__desc"
                *ngIf="r?.description"><br>{{r?.description}}</span>
            </div>
          </div>
        </div>
      </ngx-slick>
    </div>
    <app-exercise-navigation-bar [id]="id" [questionAttempted]="questionAttempted" (onNext)="next()"
      (onSubmit)="next(true)"
      [exerciseTimetrackingdata] ="exerciseTimetrackingdata"
      [index]='index'
      >
    </app-exercise-navigation-bar>
  </div>
</div>
<div *ngIf="!isSubmitted && immediateFeedBackRequired" [attr.id]="'destination'+index"
  class="new-question new-question-top-align mx-auto" [class.fullheight-scroll-container]="!isSubmitted">
  <div class="new-question__container next-button-spacing">
    <div class="new-question-para-desc pl-0 pr-0">
      <div class="new-question-para-desc__inner">
        <div class="new-question__container">
          <div [froalaView]="_element?.question" class="mg-b10 font-16 lh-30 font-mob-14 lh-mob-24"></div>
        </div>
      </div>
      <a href="javascript:void(0)" class="bottom-tab-arrow"></a>
    </div>
    <div *ngIf="showSlick" class="new-question-rating-slider">
      <ngx-slick #slickModalInner [config]="slideConfig1" (afterChange)="slickChange($event)">
        <div ngxSlickItem *ngFor="let opt of _element?.options;index as i">
          <div class="new-question--titleBox">
            <h3 class="new-question--title">{{opt.text}}</h3>
          </div>
          <div class="new-options new-options__full-width new-options--rating-list">
            <div *ngFor="let r of opt.rowsOptions;index as j"
              class="new-options--rating new-options--radio w-auto text-center">
              <input [class.disabled]="questionAttempted" type="radio" [checked]="answersMap[i] == r._id"
                (change)="radioState(i,opt._id,r._id)" [name]="opt._id">
              <span class="new-options--color"></span>
              <span class="new-options--title new-options--rating__title"><strong>{{r.text}}</strong></span>
              <span class="new-options--subtitle new-options--rating__desc"
                *ngIf="r.description"><br>{{r.description}}</span>
            </div>
          </div>
          <div class="overall-feedback pb-0" *ngIf="questionAttempted && questionChecked && opt.feedback">
            <p class=" montserrat-medium terneryColor font-14 font-mob-12 mg-b15 pd-xs-t30" *ngIf="variableFeedback">{{variableFeedback}}</p>
            <p [froalaView]="opt.feedback" class="overall-feedback__desc"></p>
          </div>
        </div>
      </ngx-slick>
    </div>
    <app-exercise-navigation-bar [id]="id" [immediateFeedBackRequired]="true" [questionAttempted]="questionAttempted"
      (onReview)="check()" (onNext)="next()" (onSubmit)="next(true)" [questionChecked]="questionChecked"
      [exerciseTimetrackingdata] ="exerciseTimetrackingdata"
      [index]='index'
      >
    </app-exercise-navigation-bar>
  </div>
</div>
<div *ngIf="isSubmitted" [attr.id]="'destination'+index" class="new-question new-question-top-align mx-auto">
  <div class="new-question__container">
    <div class="new-question-para-desc pl-0  pr-0">
      <div class="new-question-para-desc__inner">
        <div class="new-question__container">
          <div [froalaView]="_element?.question" class="mg-b10 font-16 lh-30 font-mob-14 lh-mob-24"></div>
        </div>
      </div>
      <a href="javascript:void(0)" class="bottom-tab-arrow"></a>
    </div>
    <div *ngIf="showSlick" class="new-question-rating-slider pb-5">
      <ngx-slick #slickModalInner [config]="slideConfig1" (afterChange)="slickChange($event)">
        <div ngxSlickItem *ngFor="let opt of _element?.options;index as i">
          <div class="new-question--titleBox"
            [class.score-applied]="_element?.isScoring &&  _answer && points && points.total && isResultPublished">
            <h3 class="new-question--title">{{opt.text}}</h3>
            <!-- <span *ngIf="!isPractice && _element?.isScoring &&  _answer && points && points.total && isResultPublished && !isTouchstone"
              class="answer-point">Points:
              {{(points?points.point:0 ) | number:'1.0-2'}} out of
              {{(points?points.total:0 ) | number:'1.0-2'}}</span> -->
          </div>
          <div class="new-options new-options__full-width new-options--rating-list">
            <div *ngFor="let r of opt.rowsOptions;index as j"
              class="new-options--rating new-options--radio w-auto text-center">
              <input class="disabled" type="radio" [checked]="answersMap[i] == r._id"
                (change)="radioState(i,opt._id,r._id)" [name]="opt._id">
              <span class="new-options--color"></span>
              <span class="new-options--title new-options--rating__title"><strong>{{r.text}}</strong></span>
              <span class="new-options--subtitle new-options--rating__desc"
                *ngIf="r.description"><br>{{r.description}}</span>
            </div>
          </div>
          <div class="overall-feedback" *ngIf="opt.feedback">
            <p class=" montserrat-medium terneryColor font-14 font-mob-12 mg-b15 pd-xs-t30" *ngIf="variableFeedback">{{variableFeedback}}</p>
            <p [froalaView]="opt.feedback" class="overall-feedback__desc"></p>
          </div>
        </div>
      </ngx-slick>
    </div>
  </div>
  <!-- thrive -->
  <ng-container *ngIf="questionBlos && questionBlos.length">     
    <h5 class="question__thrive">Thrive Skills:</h5>
    <div class="question__thrive-list">
      <ul>
        <ng-container *ngFor="let blo of questionBlos">
          <li [innerHTML]="blo.shortStatement"></li>
        </ng-container>
      </ul>
    </div>
  </ng-container>
  <!-- <app-like-dislike [id]="id" [userFeedback]="userFeedback" [_element]="_element"
    (reportFeedback)="_reportFeedback($event)" (likeDislike)="_likeDislike($event)">
  </app-like-dislike> -->
</div>
